import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress, Typography } from "@material-ui/core";
import { Translate as T } from "react-localize-redux";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
var useStyle = makeStyles(function (theme) { return ({
    overlay: {
        alignItems: "center",
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        display: "flex",
        height: "100%",
        justifyContent: "center",
        left: 0,
        position: "absolute",
        top: 0,
        width: "100%",
        zIndex: 800,
    },
    overlayContent: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    overlaySubtitle: {
        color: theme.palette.primary.main,
        fontSize: 20,
        fontStyle: "normal",
        fontWeight: 300,
        marginBottom: 50,
    },
    overlayTitle: {
        color: theme.palette.primary.main,
        fontSize: 40,
        fontStyle: "normal",
        fontWeight: 300,
        marginBottom: 10,
        marginTop: 20,
    },
}); });
export var LoadingOverlay = function () {
    var classes = useStyle();
    var loadingTexts = useCheckoutContext().checkoutLoadingTexts;
    return (React.createElement("div", { className: classes.overlay },
        React.createElement("div", { className: classes.overlayContent },
            React.createElement(Typography, { className: classes.overlayTitle, align: "center" }, (loadingTexts === null || loadingTexts === void 0 ? void 0 : loadingTexts.title) || React.createElement(T, { id: "loadingOverlay.mainLine" })),
            React.createElement(Typography, { className: classes.overlaySubtitle, align: "center" }, (loadingTexts === null || loadingTexts === void 0 ? void 0 : loadingTexts.subtitle) || React.createElement(T, { id: "loadingOverlay.secondaryLine" })),
            React.createElement(CircularProgress, { color: "primary", thickness: 5, size: 70 }))));
};
